import { render } from "./WorkInfoModal.vue?vue&type=template&id=204b6309&scoped=true"
import script from "./WorkInfoModal.vue?vue&type=script&lang=js"
export * from "./WorkInfoModal.vue?vue&type=script&lang=js"

import "./WorkInfoModal.vue?vue&type=style&index=0&id=204b6309&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-204b6309"]])

export default __exports__